import { Routes, RouterModule, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { HomeComponent } from './components/home/home.component';
import { AdminComponent } from './components/admin/admin.component';
import { AdminGeheimComponent } from './components/admin-geheim/admin-geheim.component';
import { ProjectItemComponent } from './components/admin-geheim/project-item/project-item.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { RESOLVED_TOKEN } from './app.tokens';

export const appRoutes: Routes = [

  {path: 'home', component: HomeComponent, data: {title: 'Über Gerd Gruber'}},
  {path: 'adminDouseiner1!', component: AdminComponent, data: {title: 'Admin-Bereich'}},
  {path: 'admin/geheim', component: AdminGeheimComponent, data: {title: 'Admin-Bereich'}},
  {path: '', redirectTo: '/home', pathMatch: 'full'},

  /** Redirect Konfigurationen **/
  {path: '**', component: NotFoundComponent}, // immer als letztes konfigurieren - erste Route die matched wird angesteuert
];

export const appRouting = RouterModule.forRoot(appRoutes);

export const routingComponents = [HomeComponent, AdminComponent, AdminGeheimComponent, ProjectItemComponent, NotFoundComponent];

export function resolveToken(route: ActivatedRouteSnapshot,
                             state: RouterStateSnapshot
) {
  return localStorage.getItem('token') || '';
}

export const routingProviders = [{ provide: RESOLVED_TOKEN, useValue: resolveToken}];
